const getReadableTime = (d: number) => {
  const minutes = Math.floor(d / 60);
  const seconds = Math.floor(d % 60);
  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
};
export default getReadableTime;
